import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { StatusCode } from "api/protocols";

import Card from "components/card/Card";
import Page from "components/page/Page";
import Input from "components/form/input/Input";
import FormLayout from "components/form/FormLayout";

import { showError } from "redux/actions/ui";

import "./newTemplate.scss";
import { PostFloorPlanTemplate } from "api/rpc/2024-04/facilityAdmin/tables/tables";
import { useAppDispatch } from "hooks/redux";
import { useHistory } from "react-router-dom";

interface IFloorPlanNewState {
  title: string;
  gridWidth: number;
  gridHeight: number;
}

export default function NewFloorPlanTemplate() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [floorPlanTemplateNewState, setFloorPlanTemplateState] = useState<IFloorPlanNewState>({
    title: "",
    gridWidth: 30,
    gridHeight: 30,
  });

  function isEmpty(value: string) {
    return value === "" || value === undefined || value === null;
  }

  async function handleSaveFloorPlan() {
    if (isEmpty(floorPlanTemplateNewState.title)) {
      dispatch(showError(t("Title is required for a floor plan")));
      return;
    }

    const newFloorPlanRes = await PostFloorPlanTemplate(
      {
        title: floorPlanTemplateNewState.title,
      },
      true,
    );

    if (newFloorPlanRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error creating floor plan")));
      return;
    }

    history.push("/admin/settings/floor-plan-template/" + String(newFloorPlanRes.data.id));
  }

  const primaryAction = {
    content: t("Create"),
    action: handleSaveFloorPlan,
  };

  return (
    <Page
      title={t("New Floor Plan Template")}
      narrow
      breadcrumbs={[
        {
          prefix: true,
          label: t("Floor Plans"),
          url: "/admin/settings/floor-plan",
        },
      ]}
      primaryAction={primaryAction}
    >
      <div>
        <Card>
          <Card.Section>
            <FormLayout>
              <FormLayout.Group>
                <Input
                  label={t("Title")}
                  value={floorPlanTemplateNewState.title}
                  onChange={(e: any) => setFloorPlanTemplateState(prev => ({ ...prev, title: e.target.value }))}
                />
              </FormLayout.Group>
            </FormLayout>
          </Card.Section>
        </Card>
      </div>
    </Page>
  );
}
